import { t } from "i18next";
import { uuid } from "uuidv4";

import {
    AdvancedDisplayName,
    ApiResponse,
    GeneralSaleSupportItem,
    SaleSupportDataMap,
    SaleSupportRowData,
    SelectOption,
    ShopSaleSupportGroup,
    TagItem,
    TranslatedSaleSupport,
    TypedTagItem,
} from "../types/index";

export type { saleSupportFormType } from "../types/index";

export const translatedSaleSupport: TranslatedSaleSupport = {
    [t("KIOSK")]: {
        fr: "KIOSK",
        en: "KIOSK",
        nl: "KIOSK",
        es: "QUIOSCO",
        pt: "QUIOSQUE",
        it: "KIOSK",
    },
    [t("POS")]: {
        fr: "POS",
        en: "POS",
        nl: "POS",
        es: "POS",
        pt: "POS",
        it: "POS",
    },
    [t("SCO")]: {
        fr: "SCO",
        en: "SCO",
        nl: "SCO",
        es: "SCO",
        pt: "SCO",
        it: "SCO",
    },
    [t("C&C App")]: {
        fr: "Application C&C",
        en: "C&C App",
        nl: "C&C App",
        es: "Aplicación C&C",
        pt: "Aplicativo C&C",
        it: "App C&C",
    },
    [t("C&C Website")]: {
        fr: "Site C&C",
        en: "C&C Website",
        nl: "C&C Website",
        es: "Sitio web C&C",
        pt: "Site C&C",
        it: "Sito web C&C",
    },
    [t("UBER")]: {
        fr: "UBER",
        en: "UBER",
        nl: "UBER",
        es: "UBER",
        pt: "UBER",
        it: "UBER",
    },
    [t("Deliveroo")]: {
        fr: "Deliveroo",
        en: "Deliveroo",
        nl: "Deliveroo",
        es: "Deliveroo",
        pt: "Deliveroo",
        it: "Deliveroo",
    },
    [t("Otter")]: {
        fr: "Otter",
        en: "Otter",
        nl: "Otter",
        es: "Otter",
        pt: "Otter",
        it: "Otter",
    },
};

export const advancedDisplayNameDefault: AdvancedDisplayName = {
    languages: {
        fr: "",
        en: "",
        nl: "",
        es: "",
        pt: "",
        it: "",
    },
};
const createSaleSupportEntry = (
    shopId: string,
    isActive: boolean,
    userID: string | number,
    franchiseID: string | number,
    operatorID: string | number,
    uuidUser: string | null,
    id: string,
    displayName: string,
    tagsData: string[],
    saleSupportLabel: string,
    advancedDisplayName: AdvancedDisplayName
) => ({
    userId: userID,
    shopId: [shopId],
    franchiseId: franchiseID,
    operatorId: operatorID,
    uuidUser: uuidUser,
    data: {
        [id]: {
            id: id,
            displayName: displayName,
            tag: tagsData.join(","),
            isArchived: false,
            isActive: isActive,
            support_de_vente: saleSupportLabel,
            shopId: shopId,
            isFavorite: isActive, // Adjust as needed
            advancedDisplayName: advancedDisplayName,
        },
    },
});

export function CreateDataSaleSupport(
    oneShop: boolean,
    isMessageValidateClicked: boolean,
    allDataShops: SaleSupportRowData[],
    userID: string | number,
    franchiseID: string | number,
    operatorID: string | number,
    uuidUser: string | null,
    id: string,
    displayName: string,
    tagsData: string[],
    saleSupportLabel: string,
    advancedDisplayName: AdvancedDisplayName,
    shopId: string,
    saleSupportData: SaleSupportRowData[]
) {
    let dataSaleSupport;

    const isActiveFranchise = saleSupportData.length === 0 ? true : false;

    const isActiveShop = allDataShops.length === 0;
    // Create the dataSaleSupport based on conditions
    if (oneShop && isMessageValidateClicked) {
        dataSaleSupport = [
            {
                ...createSaleSupportEntry(
                    shopId,
                    isActiveFranchise,
                    userID,
                    franchiseID,
                    operatorID,
                    uuidUser,
                    id,
                    displayName,
                    tagsData,
                    saleSupportLabel,
                    advancedDisplayName
                ),
                affectation: true,
            },
        ];
    } else if (oneShop && !isMessageValidateClicked) {
        dataSaleSupport = [
            createSaleSupportEntry(
                "0",
                isActiveShop,
                userID,
                franchiseID,
                operatorID,
                uuidUser,
                id,
                displayName,
                tagsData,
                saleSupportLabel,
                advancedDisplayName
            ),
            createSaleSupportEntry(
                shopId,
                isActiveFranchise,
                userID,
                franchiseID,
                operatorID,
                uuidUser,
                id,
                displayName,
                tagsData,
                saleSupportLabel,
                advancedDisplayName
            ),
        ];
    } else {
        dataSaleSupport = [
            createSaleSupportEntry(
                shopId,
                isActiveFranchise,
                userID,
                franchiseID,
                operatorID,
                uuidUser,
                id,
                displayName,
                tagsData,
                saleSupportLabel,
                advancedDisplayName
            ),
        ];
    }
    return dataSaleSupport;
}

export async function getTag(
    userID: string | number,
    shopID: string | number,
    franchiseID: string | number,
    setTags: (tags: string[]) => void,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    try {
        const newList: string[] = [];
        const result = await fetchGlobal<ApiResponse<TagItem[]>>(
            `${process.env.REACT_APP_API_V2_URL}/settings/general/tag?userId=${userID}&shopId=${shopID}&franchiseId=${franchiseID}&deviceType=tag`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        for (let element of result.data) {
            newList.push(element.Designation);
        }
        setTags(newList);
    } catch (error) {
        console.log(error);
        throw error;
    }
}
export async function getTypedTag(
    shopId: string | number,
    franchiseID: string | number,
    setTags: (tags: string[]) => void,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    try {
        const newList: string[] = [];
        const result = await fetchGlobal<ApiResponse<TypedTagItem[]>>(
            `${process.env.REACT_APP_API_V2_URL}/settings/general/typed_tag?shopId=${shopId}&franchiseId=${franchiseID}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        for (let element of result.data) {
            newList.push(element.designation);
        }
        setTags(newList);
    } catch (error) {
        console.log(error);
        throw error;
    }
}
export const fechtingLanguageList = async (
    setLanguage: (languages: string[]) => void,
    userID: string | number,
    shopId: string | number,
    franchiseID: string | number,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) => {
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    try {
        const data = await fetchGlobal<ApiResponse<string[] | undefined>>(
            `${process.env.REACT_APP_API_V2_URL}/settings/general/language?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}`,
            {
                method: "GET",
                headers: { "Accept-Language": i18nextLng },
            }
        );

        const lang: string[] =
            data.data !== undefined
                ? data.data.map((element: string) => {
                    return element;
                })
                : [];
        setLanguage(lang);
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export async function getGeneralSaleSupport(
    userID: string | number,
    shopID: string | number,
    franchiseID: string | number,
    setGeneralSalesSupports: (supports: SelectOption[]) => void,
    i18nextLng: string,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    try {
        const newList: SelectOption[] = [];
        const result = await fetchGlobal<ApiResponse<GeneralSaleSupportItem[]>>(
            `${process.env.REACT_APP_API_V2_URL}/settings/general/generalList?type=saleSupport&userId=${userID}&shopId=${shopID}&franchiseId=${franchiseID}`,
            {
                method: "GET",
                headers: { "Accept-Language": i18nextLng },
            }
        );
        for (let element of result.data) {
            newList.push({
                value: element.Id,
                label: element.Designation,
            });
        }
        setGeneralSalesSupports(newList);
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export function buildEditSaleSupportPayload(
    saleSupport: SaleSupportRowData,
    data: SaleSupportDataMap,
    shopsSaleSupportData: ShopSaleSupportGroup[],
    userID: string | number,
    franchiseID: string | number,
    operatorID: string | number,
    uuidUser: string | null
) {
    const basePayload = {
        userId: userID,
        franchiseId: franchiseID,
        operatorId: operatorID,
        uuidUser,
        isModify: true,
    };

    const shopEntries = shopsSaleSupportData
        .flatMap((el: ShopSaleSupportGroup) => el.subRows)
        .filter((shopSaleSupport: SaleSupportRowData) => shopSaleSupport.Id === saleSupport.Id)
        .map((shopSaleSupport: SaleSupportRowData) => ({
            ...basePayload,
            shopId: [shopSaleSupport.shopId],
            data: {
                [saleSupport.Id]: {
                    ...data[saleSupport.Id],
                    shopId: shopSaleSupport.shopId,
                    isFavorite: shopSaleSupport.isFavorite ?? false,
                },
            },
        }));

    return [
        ...shopEntries,
        {
            ...basePayload,
            shopId: ["0"],
            data,
        },
    ];
}

export function buildAddTagPayload(
    data: SaleSupportDataMap,
    userID: string | number,
    operatorID: string | number,
    uuidUser: string | null,
    franchiseID: string | number
) {
    const firstEntry = Object.values(data)[0];
    const tags: string[] = firstEntry.tag.split(",");

    const tagList = tags.map((el: string) => ({
        id: uuid(),
        designation: el,
    }));

    return {
        userId: userID,
        operatorId: operatorID,
        uuidUser: uuidUser,
        shopId: "0",
        franchiseId: franchiseID,
        deviceType: "tag",
        data: tagList,
    };
}

export async function editSaleSupportRequest(
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>,
    saleSupport: SaleSupportRowData,
    data: SaleSupportDataMap,
    shopsSaleSupportData: ShopSaleSupportGroup[],
    userID: string | number,
    franchiseID: string | number,
    operatorID: string | number,
    uuidUser: string | null
) {
    const dataSaleSupport = buildEditSaleSupportPayload(
        saleSupport,
        data,
        shopsSaleSupportData,
        userID,
        franchiseID,
        operatorID,
        uuidUser
    );

    const result = await fetchGlobal<ApiResponse>(
        `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport`,
        {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(dataSaleSupport),
        }
    );

    if (result.error) throw new Error(result.message);
    return result;
}

export async function addTagRequest(
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>,
    data: SaleSupportDataMap,
    userID: string | number,
    operatorID: string | number,
    uuidUser: string | null,
    franchiseID: string | number
) {
    const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/tagList`;
    const dataTag = buildAddTagPayload(
        data,
        userID,
        operatorID,
        uuidUser,
        franchiseID
    );

    const response = await fetchGlobal<ApiResponse>(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataTag),
    });

    if (response.error) throw new Error(response.message);
}

export function ArchivedSaleSupport(e: SaleSupportRowData, shopsSaleSupportData: ShopSaleSupportGroup[]) {
    let idsAssociated = ["0"];
    if (shopsSaleSupportData !== undefined) {
        shopsSaleSupportData.forEach((element: ShopSaleSupportGroup) => {
            element.subRows.forEach((el: SaleSupportRowData) => {
                if (el.Id === e.Id) idsAssociated.push(el.shopId);
            });
        });
    }
    idsAssociated = [...new Set(idsAssociated)];

    return idsAssociated;
}
